/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, Input} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {IxModule} from '@siemens/ix-angular';
import {
  SubmodelElement,
  SubmodelElementCollection,
  SubmodelElementList,
  SubmodelElementTypes,
} from '@product-passport/dpp/model';
import {PropertyComponent} from '../property/property.component';
import {FileComponent} from '../file/file.component';
import {MultiLanguagePropertyComponent} from '../multi-language-property/multi-language-property.component';
import {SubmodelElementListComponent} from '../submodel-element-list/submodel-element-list.component';
import {TranslateOrFallbackPipe} from '../../../dpp-submodel-field/utils/translate-or-fallback.pipe';

@Component({
  selector: 'app-submodel-element',
  templateUrl: './submodel-element.component.html',
  styleUrl: './submodel-element.component.scss',
  imports: [
    IxModule,
    ReactiveFormsModule,
    PropertyComponent,
    FileComponent,
    MultiLanguagePropertyComponent,
    SubmodelElementListComponent,
    SubmodelElementComponent,
    TranslateOrFallbackPipe,
  ],
})
export class SubmodelElementComponent {
  @Input({required: true}) element!: SubmodelElement;
  @Input({required: true}) control!: AbstractControl;

  protected readonly SubmodelElementTypes = SubmodelElementTypes;

  get collectionChildren(): SubmodelElement[] {
    return (this.element as SubmodelElementCollection).value ?? [];
  }

  getChildControl(idShort: string): AbstractControl {
    return (this.control as FormGroup).get(idShort) ?? new FormControl('');
  }

  asSubmodelElementList(e: SubmodelElement): SubmodelElementList {
    return e as SubmodelElementList;
  }

  asFormArray(c: AbstractControl): FormArray {
    return c as FormArray;
  }
}
